import { render, staticRenderFns } from "./OwnerForm.vue?vue&type=template&id=b72e023c&"
import script from "./OwnerForm.vue?vue&type=script&lang=js&"
export * from "./OwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnerForm.vue?vue&type=style&index=0&id=b72e023c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports